import { queryOptions } from '@tanstack/react-query'
import { getEventGroupsFromRoot, getGroupHighlights } from '../api/groups'
import { sportsOfferingQueryKeys } from './keys'
import { getKambiBetOffersByIds, getKambiBetOffersByEventIds } from '../api/betOffers'
import { getPreMatchCategoryForSport } from '../api/categories'
import { getEventsBySportTermKey, getUpcomingEventsForAllSports } from '../api/events'
import {
  getEventsForLeague as getKambiEventsForCompetition,
  getFuturesEventsForCompetition,
} from '../api/listView'

export const getEventGroupsFromRootQuery = queryOptions({
  queryFn: getEventGroupsFromRoot,
  queryKey: sportsOfferingQueryKeys.EventGroupsFromRoot,
  refetchOnWindowFocus: false,
  staleTime: 1_000 * 60 * 2, // 2min
})

export const getMatchesBySportTermKeyQuery = (sport: string) =>
  queryOptions({
    queryFn: () => getEventsBySportTermKey(sport),
    queryKey: sportsOfferingQueryKeys.EventsForSport(sport),
    refetchOnWindowFocus: false,
    staleTime: 1_000 * 60 * 2, // 2min
  })

export const getGroupHighlightsQuery = queryOptions({
  queryFn: getGroupHighlights,
  queryKey: sportsOfferingQueryKeys.EventGroupHighlights,
  refetchOnWindowFocus: false,
  staleTime: 1_000 * 60 * 2, // 2min
})

export const getUpcomingEventsForAllSportsQuery = queryOptions({
  queryFn: getUpcomingEventsForAllSports,
  queryKey: sportsOfferingQueryKeys.UpcomingEventsForAllSports,
  refetchOnWindowFocus: false,
  staleTime: 1_000 * 60 * 2, // 2min
})

export const getPreMatchCategoryForSportQuery = (sportTerm: string) =>
  queryOptions({
    queryFn: () => getPreMatchCategoryForSport(sportTerm),
    queryKey: ['sport', 'pre-match-category', sportTerm],
    refetchOnWindowFocus: false,
    staleTime: 1_000 * 60 * 2,
  })

export const getKambiBetOffersByIdsQuery = (betOfferIds: number[]) =>
  queryOptions({
    queryFn: () => getKambiBetOffersByIds({ betOfferIds }),
    queryKey: sportsOfferingQueryKeys.BetOffersByIds(betOfferIds),
    staleTime: 1_000 * 60 * 10, // 10min
  })

export const getKambiBetOffersByEventIdQuery = (eventId: number) =>
  queryOptions({
    queryFn: () => getKambiBetOffersByEventIds({ eventIds: [eventId] }),
    queryKey: sportsOfferingQueryKeys.BetOffersByEvents([eventId]),
    refetchOnWindowFocus: false,
  })

export const getKambiBetOffersByEventIdsQuery = (eventIds: number[]) =>
  queryOptions({
    queryFn: () =>
      eventIds.length !== 0 ? getKambiBetOffersByEventIds({ eventIds }) : Promise.resolve(null),
    queryKey: sportsOfferingQueryKeys.BetOffersByEvents(eventIds),
    staleTime: 1_000 * 60 * 10, // 10min
  })

export const getMatchesForCompetitionQuery = (sport: string, region: string, competition: string) =>
  queryOptions({
    queryFn: () => getKambiEventsForCompetition(sport, region, competition, 'all'),
    queryKey: [sportsOfferingQueryKeys.EventsForCompetition(sport, region, competition), 'matches'],
    refetchOnWindowFocus: false,
    staleTime: 1_000 * 60 * 2, // 2min
  })

export const getFuturesMatchesForCompetitionQuery = (
  sport: string,
  region: string,
  competition: string
) =>
  queryOptions({
    queryFn: () => getFuturesEventsForCompetition(sport, region, competition),
    queryKey: [sportsOfferingQueryKeys.EventsForCompetition(sport, region, competition), 'futures'],
    refetchOnWindowFocus: false,
    staleTime: 1_000 * 60 * 2, // 2min
  })
